import React, { useEffect, useState } from 'react';
import { useTypedSelector } from '../../Hooks/useTypedSelector';
import NavigationLink from './NavigationLink';

const Navigation = () => {
  const { contentLinks, rightContentLinks } = useTypedSelector<any>(
    (state) => state.navigation
  );

  const [activeMegaMenuLink, setActiveMegaMenuLink] = useState<any>();
  const [blockElements, setBlockElements] = useState<any[]>([]);

  const onLinkClick = (link) => {
    if (activeMegaMenuLink) {
      setActiveMegaMenuLink(null);
    }
    setActiveMegaMenuLink(link);
  };

  const onMegaMenuClose = () => setActiveMegaMenuLink(null);

  useEffect(() => {
    const blockElementsContainer =
      document.getElementById('mega-menu-blocks');
    const blockElements = blockElementsContainer
      ? Array.from(blockElementsContainer.children)
      : [];
    setBlockElements(blockElements);
  }, []);

  return contentLinks?.length > 0 || rightContentLinks?.length > 0 ? (
    <div className="hidden store-screen:hidden lg:block">
      <div className="container z-50 flex h-full justify-between">
        <div className="flex h-full gap-4 py-2">
          {contentLinks.map((link) => (
            <NavigationLink
              key={link.url + link.name + 'NavigationLink'}
              link={link}
              isActive={activeMegaMenuLink == link}
              onMegaMenuClose={onMegaMenuClose}
              onLinkClick={() => onLinkClick(link)}
              blocks={blockElements?.filter(
                (b) =>
                  link.blockSystemIds.indexOf(
                    b.dataset['litiumBlockId']
                  ) != -1
              )}
            />
          ))}
        </div>
      </div>
    </div>
  ) : null;
};

export default Navigation;
